import axios from "axios";
import Config from "../utils/Config";

class MeetingIntegrationService {
    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    //set access token
    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
    }

    //get company config
    async getCompanyConfig (companyId, accessToken){
        this.setAccessToken(accessToken, companyId);
        
        const data = await axios.get(
            Config.BACKEND_URL + `/api/company/config`, ///api/company/config
            this.config
          )
          return data.data;
      }

    //check zoom account
    async getZoomAccount (formData, companyId, accessToken){
        this.setAccessToken(accessToken, companyId);
        //console.log(formData);
        const data = await axios.post(
            Config.BACKEND_URL + `/api/company/checkZoomAccount`, //api/company/checkZoomAccount
            formData,
            this.config
          )
          return data.data;
      }

    //check teams account
    async getTeamsAccount (formData, companyId, accessToken){
        this.setAccessToken(accessToken, companyId);
        const data = await axios.post(
            Config.BACKEND_URL + `/api/company/checkTeamsAccount`, //api/company/checkZoomAccount
            formData,
            this.config
          )
          return data.data;
      }

    //check google service account
    async getGoogleServiceAccount (formData, companyId, accessToken){
        this.setAccessToken(accessToken, companyId);
        //console.log(JSON.stringify(accessToken));
        const data = await axios.post(
            Config.BACKEND_URL + `/api/company/checkGoogleServiceAccount`, //api/company/checkGoogleServiceAccount
            formData,
            this.config
          )
          return data.data;
      }

    //update company settings
    async updateCompanySettings(formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        //console.log(JSON.stringify(formData));
        const data = await axios.put(
          Config.BACKEND_URL + `/api/company/updateCompanyAndConfig`,  //api/company/updateCompanyAndConfig
          formData,
          this.config
        )
        return data.data;
      }

    //delete company config
    async deleteCompanyConfig(configId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.delete(
          Config.BACKEND_URL + `/api/company/onlineConfig/${configId}`,  //api/company/onlineConfig/670f7235c153cb82eb916376
          this.config
        )
        return data.data;
      }

    //update meeting status
    async updateMeetingStatus(configId, formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        //console.log(accessToken);
        const data = await axios.put(
          Config.BACKEND_URL + `/api/company/config/updateStatus/${configId}`,  //api/company/config/updateStatus/66a00bedde8b3f505061424d
          formData,
          this.config
        )
        return data.data;
      }

    //updateCompanyConfig

};

export default new MeetingIntegrationService();